import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    //   mode: "history",
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: [
        {
            path: "/index",
            name: "index",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/index/index.vue")
        },
        {
            path: "/",
            redirect: {
                name: "index"
            }
        },
        {
            path: "/user",
            name: "user",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/index.vue")
        },
		{
		    path: "/kamiInfo",
		    name: "kamiInfo",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/kamiInfo.vue")
		},
		{
		    path: "/funds",
		    name: "funds",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/funds.vue")
		},
		{
		    path: "/recharge",
		    name: "recharge",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/recharge.vue")
		},
		{
		    path: "/coupon",
		    name: "coupon",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/coupon.vue")
		},
		{
		    path: "/address",
		    name: "address",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/address.vue")
		},
		{
		    path: "/editaddress/:id?",
		    name: "editaddress",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/editaddress.vue")
		},
		{
		    path: "/newshop",
		    name: "newshop",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/index/newshop.vue")
		},
		{
		    path: "/logistics",
		    name: "logistics",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/logistics.vue")
		},
		{
		    path: "/logistics/:id",
		    name: "logisticsdetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/logdetail.vue")
		},
        {
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/login.vue")
        },
        {
            path: "/register",
            name: "register",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/register.vue")
        },
        {
            path: "/forgetpwd",
            name: "forgetpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/forgetpwd.vue")
        },
        {
            path: "/safe",
            name: "safe",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/safe.vue")
        },
        {
            path: "/account",
            name: "account",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/account.vue")
        },
        {
            path: "/addcount",
            name: "addcount",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/addcount.vue")
        },
        {
            path: "/cash",
            name: "cash",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/cash.vue")
        },
        {
            path: "/setpwd",
            name: "setpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpwd.vue")
        },
        {
            path: "/setpaypwd",
            name: "setpaypwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpaypwd.vue")
        },
        {
            path: "/notice",
            name: "notice",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice.vue")
        },
        {
            path: "/notice/:id",
            name: "noticeid",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice_article.vue")
        },
        {
            path: "/about",
            name: "about",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/about.vue")
        },
        {
            path: "/about/:code",
            name: "article",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/article.vue")
        },
        {
            path: "/item",
            name: "item",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/item/item.vue")
        },
		{
		    path: "/search",
		    name: "search",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/search.vue")
		},
		{
		    path: "/type",
		    name: "type",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/type.vue")
		},
		{
		    path: "/confirm",
		    name: "confirm",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/confirm.vue")
		},
		{
		    path: "/pay",
		    name: "pay",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/pay.vue")
		},
		{
		    path: "/agencyPay",
		    name: "agencyPay",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/agencyPay.vue")
		},
		{
		    path: "/seckill",
		    name: "seckill",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/index/seckill.vue")
		},
        {
            path: "/details/:id",
            name: "details",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/item/details.vue")
        },
        {
            path: "/kefu",
            name: "kefu",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/kefu.vue")
        },
        {
            path: "/auth",
            name: "auth",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/auth.vue")
        },
	    {
            path: "/useragreement",
            name: "useragreement",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/useragreement.vue")
        },
        {
            path: "/privacyPolicy",
            name: "privacyPolicy",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/privacyPolicy.vue")
        },
		{
		    path: "/cart",
		    name: "cart",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/cart.vue")
		},
		{
		    path: "/shopRecycle",
		    name: "shopRecycle",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/shopRecycle.vue")
		},
		{
		    path: "/shopOrders",
		    name: "shopOrders",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/shopOrders.vue")
		},
		{
		    path: "/shopOrderDetail/:id",
		    name: "shopOrderDetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/shopOrderDetail.vue")
		},
    ]
});
